import ModalUpload from './modal-upload.component'

export default ModalUpload